/**
 * Categorías del club, en un solo sitio.
 *
 * Las de networking (a qué se dedica cada miembro) las usan el registro, el
 * perfil y el filtro de la pestaña Networking; las de proyectos, el formulario
 * de proyecto y el filtro del listado. Si se duplicaran, un filtro acabaría
 * ofreciendo categorías que ya nadie puede elegir.
 *
 * El backend tiene la lista de networking en utils/networkingCategories.js
 * para validar lo que llega: si se toca una, hay que tocar la otra (el orden
 * da igual, allí solo se comprueba que la categoría exista).
 */

/** Cajón de sastre: va siempre al final, por mucho que ordenemos. */
const OTHERS = ["Otros", "Otras"];

/**
 * Ordena alfabéticamente en español (que la ñ y los acentos caigan donde toca)
 * dejando el cajón de sastre al final: es una opción de descarte, y arriba
 * entre las demás invita a elegirla sin mirar el resto.
 */
export const sortCategories = (categories) =>
  [...categories].sort((a, b) => {
    const aIsOther = OTHERS.includes(a);
    const bIsOther = OTHERS.includes(b);
    if (aIsOther !== bIsOther) return aIsOther ? 1 : -1;
    return a.localeCompare(b, "es");
  });

/** A qué se dedica cada miembro dentro del mundo del motor. */
export const NETWORKING_CATEGORIES = sortCategories([
  "Ingeniero de motorsport",
  "Diseñador conceptual (styling)",
  "Formador",
  "Restaurador",
  "Periodista-Comunicación",
  "Influencer",
  "Coachbuilder/artesano/constructor",
  "Ingeniero en OEM/Tier1",
  "Desarrollador/informático",
  "Piloto",
  "Mecánico de competición",
  "Soldador de chasis",
  "Especialista en fibra",
  "Diseñador CAD paramétrico",
  "Organizador de eventos/tandas",
  "Especialista en marketing",
  "Desarrollo profesional en automoción",
  "Especialista en aerodinámica",
  "Especialista en dinámica vehicular",
  "Especialista en movilidad urbana",
  "Especialista en ADAS",
  "Ingeniero electrónico",
  "Comercial de automóviles",
  "Pintor de automóviles",
  "Gerencia de empresas automotrices",
  "Especialista en motorsport",
  "Otros"
]);

/** Como máximo cada miembro puede elegir estas categorías. */
export const MAX_NETWORKING_CATEGORIES = 5;

/** De qué va un proyecto del club. */
export const PROJECT_CATEGORIES = sortCategories([
  "Detailing",
  "Apps",
  "Motorsport",
  "Mecánica de competición",
  "Preparación y personalización de vehículos",
  "Restauración",
  "Organización de eventos",
  "Organización de tandas",
  "Marketing de automoción",
  "Coachbuilder",
  "Fabricación de vehículos",
  "Medios de comunicación",
  "Social media / Influencer",
  "Homologación de vehículos",
  "Formación automotriz",
  "Comercialización y exportación (vehículos)",
  "Diseño de vehículos (styling)",
  "Diseño de vehículos (ingeniería y desarrollo)",
  "Desarrollo profesional",
  "Otros"
]);
